import React from 'react';
import { Form } from 'react-bootstrap';
import { User, Camera } from 'lucide-react';
import OnboardingLayout from './OnboardingLayout';
import { Link } from 'react-router-dom';

const ProfileSetup = () => (
  <OnboardingLayout>
    <div className="px-md-2">
      <h2 className="fw-bold mb-1 text-dark" style={{ letterSpacing: '-0.02em' }}>
        Set up your profile
      </h2>
      <p className="text-muted mb-5 small">
        Add a photo and tell us where you're working from.
      </p>

      {/* Profile Image Section */}
      <div className="text-center mb-5 position-relative mx-auto" style={{ width: 'fit-content' }}>
        <div className="profile-avatar-wrapper position-relative">
          <div className="bg-light rounded-circle d-flex align-items-center justify-content-center border border-2 border-white shadow-sm mx-auto" 
               style={{ width: '120px', height: '120px' }}>
            <User size={48} className="text-secondary opacity-25" />
          </div>
          {/* The Camera Icon Button exactly as shown in the photo */}
          <button className="position-absolute d-flex align-items-center justify-content-center border-0 rounded-3 shadow-sm p-2 text-white" 
                  style={{ 
                    bottom: '8px', 
                    right: '8px', 
                    backgroundColor: '#00629b',
                    width: '32px',
                    height: '32px'
                  }}>
            <Camera size={16} strokeWidth={2.5} />
          </button>
        </div>
        <button className="btn btn-link text-primary text-decoration-none small fw-bold mt-3 d-block w-100 p-0 shadow-none">
          Upload new picture
        </button>
      </div>

      {/* Form Section */}
      <Form.Group className="mb-4">
        <Form.Label className="small fw-bold text-muted ms-1 mb-2">Display Name</Form.Label>
        <Form.Control 
          type="text" 
          placeholder="Za Dump Guy" 
          className="custom-input py-3 px-4 rounded-3 border" 
          style={{ 
            fontSize: '0.95rem',
            backgroundColor: '#f8fafc',
            borderColor: '#e2e8f0'
          }} 
        />
      </Form.Group>

      {/* Full-width primary button */}
      <Link to='/step-3'
        className="btn btn-ieee-primary flex-grow-1 d-flex align-items-center justify-content-center" 
        style={{ 
          backgroundColor: '#00629b',
          borderRadius: '12px'
        }}
      >
        Continue
      </Link>
    </div>
  </OnboardingLayout>
);

export default ProfileSetup;
